import { useToastContext } from "components/alert/ToastContext";
import BaseListagem from "components/BaseListagem";
import Usuario from "model/administracao/cadastro/Usuario";
import Veiculo from "model/gestao/frotas/Veiculo";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import VeiculoViagemService from "service/gestao/frotas/VeiculoViagemService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterData } from "utils/convert";
import { DateMatchModeOptions, IdMatchModeOptions, ListMatchModeOptions, dateRangeFilterTemplate, dropdownFilterTemplate, filterApplyTemplate, statusFilterTemplate } from "utils/filterUtils";

const service = new VeiculoViagemService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function VeiculoViagemListagem() {

    const [queryParameters] = useSearchParams();

    const { msgErro } = useToastContext();

    const [veiculos, setVeiculos] = useState<Veiculo[]>([]);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);

    const [titulo, setTitulo] = useState<string>('Viagens de veículos');

    const { startLoading, stopLoading } = useLoadingContext();

    useEffect(() => {
        service.veiculosDisponiveis().then(data => setVeiculos(data)).catch(erro => console.log(erro));
        service.getUsuarios().then(data => setUsuarios(data)).catch(erro => console.log(erro));
    }, [])


    const defaultFilters: DataTableFilterMeta = {
        
        inicioViagem: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },

        veiculo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        motorista: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);

    return (
        <>
            <BaseListagem
                ordenacao="inicioViagem,DESC" service={service} urlService="/veiculoViagem" tituloPagina={titulo} 
                defaultFilters={defaultFilters} showClearFilterButton nome="veiculoViagem" 
                showNewButton={false} showRemoveButton={false}
                onChangeFilters={(filters) => setFilters(filters)}>

                <Column field="inicioViagem" header="Data" body={(rowData) => converterData(rowData.inicioViagem)} style={{ width: '10%' }}
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={dateRangeFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />

                <Column field="veiculo.identificador" header="Veiculo" body={(rowData) => rowData.veiculo.placa + " - " + rowData.veiculo.modelo} style={{ width: '40%' }} filterField="veiculo"
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={(options)=>dropdownFilterTemplate(options, veiculos, "modelo")} />

                <Column field="motorista.nome" header="Motorista" style={{ width: '30%' }} filterField="motorista"
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={(options)=>dropdownFilterTemplate(options, usuarios)} />

                <Column field="status" header="Status" body={(rowData) => service.getStatus(rowData.status)} style={{ width: '10%' }}
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={(options)=>statusFilterTemplate(options, service.getStatusesFilter())} />
            </BaseListagem>
        </>

    )
}